"use client"

import { useDraggable, UseDraggableArguments, useDroppable, UseDroppableArguments } from "@dnd-kit/core"
import clsx from "clsx"
import { ReactNode } from "react"
import { CSS } from "@dnd-kit/utilities"

export function Draggable(props: UseDraggableArguments & { className?: string, children: ReactNode, pos: { x: number, y: number } }) {
  const { className, pos, children, ...rest } = props
  const { transform, setNodeRef, attributes, listeners } = useDraggable(rest)
  const style = {
    transform: CSS.Transform.toString(transform ? {
      ...transform,
      scaleX: 1.1,
      scaleY: 1.1
    } : null),
  }
  return (
    <div
      {...attributes} {...listeners}
      ref={setNodeRef}
      style={{
        ...style, touchAction: "none", position: "absolute",
        left: pos.x, top: pos.y
      }}
      className={clsx(className, "w-fit h-fit")}
    >
      {children}
    </div>
  )
}

export function Droppable(props: { children: ReactNode, className?: string } & UseDroppableArguments) {
  const { children, className, ...rest } = props
  const {
    setNodeRef,
  } = useDroppable({ ...rest })

  return (
    <div ref={setNodeRef} className={className}>
      {children}
    </div>
  )
}